import React from 'react';
import { FaGithub, FaLinkedin } from "react-icons/fa";

const Home = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-start p-4 pt-10">
      {/* Profile Card */}
      <div className="max-w-4xl w-full bg-white rounded-xl shadow-xl p-4 md:p-6 transform transition-all duration-500 border-l-4 border-blue-400 mt-20">
        <div className="flex flex-col items-center">
          <img
            src={"/pfp.jpg"}
            alt="Profile"
            className="w-24 md:w-32 h-24 md:h-32 rounded-full border-4 border-white shadow-md"
          />
          <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mt-4">Ben Gridley</h1>

          <p className="text-gray-600 text-center mt-2">
            Welcome to my website and resume!
          </p>

          <p className="text-gray-600 text-center mt-2">
            I like backend development, skiing, golfing, camping, and biking.
          </p>

          <div className="flex items-center justify-center space-x-4 mt-4">
            <a href="https://github.com/bggridley" target="_blank" rel="noreferrer">
              <FaGithub size={30} className="hover:text-gray-600" />
            </a>
            <a href="https://linkedin.com/in/bggridley" target="_blank" rel="noreferrer">
              <FaLinkedin size={30} className="hover:text-gray-600" />
            </a>
          </div>
        </div>
      </div>

      {/* About Me Section */}
      <div
        id="about"
        className="mt-5 mb-5 p-4 md:p-6 max-w-4xl w-full bg-white rounded-xl shadow-xl transform transition-all duration-500 border-l-4 border-blue-400"
      >
        <h2 className="text-xl md:text-2xl font-bold text-gray-800">About Me</h2>
        <p className="text-gray-600 mt-2 leading-relaxed">
          Software Engineer @ 10x People. I am experienced in backend development, cloud infrastructure, and high availability deployments. I enjoy building efficient and scalable solutions.
        </p>

        <hr className="my-4 border-gray-300" />

        <p className="text-sm md:text-base text-gray-600 mt-6 leading-relaxed">
          I mostly work with Java, Python, and TypeScript in my professional career and have experience with Go, C++, C. I've been spending some time building a game engine from scratch with Rust.
        </p>

        <hr className="my-4 border-gray-300" />

        <p className="text-sm md:text-base text-gray-600 mt-6 leading-relaxed">
          I maintained an existing project and contributed to the growth of 1500+ users at Golfsnake from 2023 to 2024. Full stack development and SRE experience within two tech startups in 2023. DU microgrant recipient.
        </p>

        <hr className="my-4 border-gray-300" />

        <p className='text-sm md:text-base text-gray-600 mt-6 leading-relaxed'>
          Blockchain experimentation with highschool startup Peak Media LLC, smart contracts and Solidity starting in 2021.
        </p>

        <hr className="my-4 border-gray-300" />

        <p className='text-sm md:text-base text-gray-600 mt-6 leading-relaxed'>
          3D graphics experience with OpenGL, optimizing voxel engines, manual vertex generation, starting in 2020.
        </p>

        <hr className="my-4 border-gray-300" />

        <p className='text-sm md:text-base text-gray-600 mt-6 leading-relaxed'>
          Fundamentals of full-stack development in 2020 creating statistic-tracking website for high school league. Excel spreadsheet manipulation, inventory tracking systems 2017. C++ experience in 2018 through UC Berkeley online-learning.
        </p>

        <hr className="my-4 border-gray-300" />

        <p className='text-sm md:text-base text-gray-600 mt-6 leading-relaxed'>
          Video game modding (Java), game development, server management, plugin development with MySQL starting in 2013.
        </p>
      </div>

      {/* Education Section */}
      <div
        id="education"
        className="mb-5 p-4 md:p-6 max-w-4xl w-full bg-white rounded-xl shadow-xl transform transition-all duration-500 border-l-4 border-blue-400"
      >
        <h2 className="text-xl md:text-2xl font-bold text-gray-800">Education & Other Accomplishments</h2>
        <p className="text-sm md:text-base text-gray-600 mt-2 leading-relaxed">
          I graduated Cum Laude from the University of Denver in June 2025 with a B.S. in Computer Science + a minor in Mathematics and Physics. My major GPA was 3.97.
        </p>

        <p className='text-sm md:text-base text-gray-600 mt-3 leading-relaxed'>
          In terms of other education, I completed <a className="text-blue-600 font-bold" href="https://specterops.io/training/tradecraft-analysis/">SpecterOp's Adversary Tactics: Tradecraft Analysis</a>, a 32 hour course on low level system security.
        </p>

        <p className='text-sm md:text-base text-gray-600 mt-3 leading-relaxed'>
          I participated in the <a className="text-blue-600 font-bold" href="https://denmark2024.honeynet.org/">Honeynet Project 2024 CTF</a>, where I placed 3rd.
        </p>
      </div>
    </div>
  );
};

export default Home;
